<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button (click)="scrollToTop()">
        <i class="fa fa-chevron-up"></i>
    </button>
</div>